import React from 'react'

const Unlock = () => {
    return (
        <div className="unlock-root">
            <style>{`
        .unlock-root {
          background: #fafafa;
          min-height: 100vh;
          padding: 40px 0;
        }
        .unlock-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          gap: 40px;
          align-items: center;
          border-radius: 12px;
        }
        .unlock-left {
          flex: 1;
          padding: 40px 0 40px 40px;
        }
        .unlock-badge {
          background: #ffe9f0;
          color: #ff4081;
          display: inline-block;
          padding: 4px 16px;
          border-radius: 20px;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .unlock-title {
          font-size: 36px;
          font-weight: 700;
          color: #23235f;
          margin: 16px 0 8px;
        }
        .unlock-title .highlight {
          color: #ff0000;
        }
        .unlock-desc {
          color: #888;
          font-size: 16px;
          margin-bottom: 32px;
        }
        .unlock-img {
          max-width: 340px;
          border-radius: 16px;
          margin-top: 24px;
          width: 100%;
          height: auto;
        }
        .unlock-form-section {
          flex: 1.2;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.06);
          padding: 40px;
        }
        .unlock-form-title {
          color: #23235f;
          font-weight: 700;
          font-size: 22px;
          margin-bottom: 24px;
        }
        .unlock-form {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }
        .unlock-form input,
        .unlock-form select {
          width: 100%;
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #e0e0e0;
          font-size: 16px;
          margin-top: 4px;
          margin-bottom: 8px;
          background: #fafbfc;
        }
        .unlock-form label {
          font-size: 15px;
          font-weight: 500;
        }
        .unlock-form .checkbox-label {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
        .unlock-form .checkbox-label input[type="checkbox"] {
          margin-right: 8px;
        }
        .unlock-form .unlock-submit-btn {
          background: #ff0000;
          color: #fff;
          border: none;
          border-radius: 24px;
          padding: 14px 0;
          width: 100%;
          font-weight: 600;
          font-size: 18px;
          cursor: pointer;
          margin-top: 16px;
        }
        @media (max-width: 900px) {
          .unlock-container {
            flex-direction: column;
            gap: 0;
          }
          .unlock-left {
            padding: 32px 24px 0 24px;
            text-align: center;
          }
          .unlock-form-section {
            padding: 32px 16px;
            width: 100%;
            box-sizing: border-box;
          }
        }
        @media (max-width: 600px) {
          .unlock-root {
            padding: 16px 0;
          }
          .unlock-title {
            font-size: 24px;
          }
          .unlock-form-title {
            font-size: 18px;
          }
          .unlock-img {
            max-width: 220px;
            margin-top: 16px;
          }
        }
      `}</style>
            <div className="unlock-container">
                {/* Left Section */}
                <div className="unlock-left" data-aos="fade-up-right">
                    <div className="unlock-badge">Get FREE Counselling Today!</div>
                    <h1 className="unlock-title">
                        Unlock Your Global Future<br />
                        with <span className="highlight">Palanivel Overseas</span>
                    </h1>
                    <p className="unlock-desc">
                        Enter your details and our expert will reach out to you to discuss your plans. By the way, all our services are free!
                    </p>
                    <img className="unlock-img hidden md:block" src="https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg?auto=compress&w=400" alt="Woman pointing" />
                </div>
                {/* Right Section (Form) */}
                <div className="unlock-form-section" data-aos="fade-up-left">
                    <h2 className="unlock-form-title">
                        Get Expert Guidance – Book Your FREE Consultation Today!
                    </h2>
                    <form className="unlock-form">
                        <div style={{ flex: '1 1 45%' }}>
                            <label>First Name <span style={{ color: 'red' }}>*</span></label>
                            <input type="text" placeholder="" />
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>Last Name <span style={{ color: 'red' }}>*</span></label>
                            <input type="text" placeholder="" />
                        </div>
                        <div style={{ flex: '1 1 100%' }}>
                            <label>Email address <span style={{ color: 'red' }}>*</span></label>
                            <input type="email" placeholder="" />
                        </div>
                        <div style={{ flex: '1 1 100%' }}>
                            <label>Mobile number <span style={{ color: 'red' }}>*</span></label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ background: '#f3f3f3', padding: '0 12px', borderRadius: 6, border: '1px solid #eee', height: 40, display: 'flex', alignItems: 'center' }}>+91 <img src="https://flagcdn.com/in.svg" alt="IN" style={{ width: 20, marginLeft: 4 }} /></span>
                                <input type="tel" style={{ flex: 1 }} placeholder="" />
                            </div>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>Preferred Study destination</label>
                            <select><option>Select</option></select>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>When would you like to start? <span style={{ color: 'red' }}>*</span></label>
                            <select><option>Select</option></select>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>Nearest IDP Office <span style={{ color: 'red' }}>*</span></label>
                            <select><option>Select</option></select>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>Preferred mode of counselling <span style={{ color: 'red' }}>*</span></label>
                            <select><option>Select</option></select>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>Preferred study level <span style={{ color: 'red' }}>*</span></label>
                            <select><option>Select</option><option>1</option><option>2</option></select>
                        </div>
                        <div style={{ flex: '1 1 45%' }}>
                            <label>How will you fund your studies? <span style={{ color: 'red' }}>*</span></label>
                            <select><option>Select</option><option>1</option><option>2</option></select>
                        </div>
                        <div style={{ flex: '1 1 100%', marginTop: 8 }}>
                            <div
                                className="unlock-radio-group"
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 12,
                                    flexDirection: 'row',
                                }}
                            >
                                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                                   <span>
                                    <input type="checkbox" className="mt-0.5" />

                                   </span>
                                    <span>
                                        I agree to Palanivel Overseas{' '}
                                        <a href="#" className="text-[#ff0000] underline mx-1">Terms</a>
                                        {' '}and{' '}
                                        <a href="#" className="text-[#ff0000] underline mx-1">Privacy policy</a>
                                    </span>
                                </label>
                                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                                   <span>
                                   
                                    <input type="checkbox" className="mt-0.5" />
                                   </span>
                                    <span>
                                        Please contact me by phone, email or SMS to assist my enquiry
                                    </span>
                                </label>
                                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                                   <span>

                                    <input type="checkbox" className="mt-0.5" />
                                    </span>
                                    <span>
                                        I would like to receive updated and offer from Palanivel Overseas
                                    </span>
                                </label>
                            </div>
                            <style>{`
    @media (max-width: 700px) {
      .unlock-radio-group {
        flex-direction: column !important;
        gap: 8px !important;
      }
    }
    .checkbox-label {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
    }
    .checkbox-label input[type="radio"] {
      margin-top: 2px;
    }
  `}</style>
                        </div>
                        <div style={{ flex: '1 1 100%' }}>
                            <button type="submit" className="unlock-submit-btn">
                                Start your journey now
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Unlock
